import { render, staticRenderFns } from "./user-review-form.vue?vue&type=template&id=3fe07f9a&scoped=true"
import script from "./user-review-form.vue?vue&type=script&lang=js"
export * from "./user-review-form.vue?vue&type=script&lang=js"
import style0 from "./user-review-form.vue?vue&type=style&index=0&id=3fe07f9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe07f9a",
  null
  
)

export default component.exports